import { render, staticRenderFns } from "./buyerVisitLogDetail.vue?vue&type=template&id=08dbb386&"
import script from "./buyerVisitLogDetail.vue?vue&type=script&lang=js&"
export * from "./buyerVisitLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./buyerVisitLogDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports